// Local development only — never active in production.
// Enable with: REACT_APP_FAKE_API=true REACT_APP_FAKE_PERMISSIONS="job:read admin:read" craco start
//
// Intercepts ApiClient.fetch and returns canned responses so the Offers page
// works without a running tp-web-service / ATMSAssignment / ATMSWeb stack.

const DAY_MS = 24 * 60 * 60 * 1000;
// Includes a saved filter without a status token to demo the ATMS-34356 mandate.

const FAKE_OFFERS = [
  {
    id: 'offer-1',
    name: 'homepage_v2_en_es.xliff',
    jobPartId: 100001,
    status: 'OPEN',
    clientName: 'Audible',
    clientUri: 'web:clientName:Audible',
    freelancerUsername: null,
    sourceLocale: 'en_US',
    targetLocale: 'es_ES',
    translationSkill: 'TRANSLATION',
    mediaType: 'SOFTWARE',
    subject: 'TECHNICAL',
    workUnits: 1240,
    weightedWorkUnits: 1054,
    price: '24.80',
    currency: 'USD',
    dateCreated: new Date(Date.now() - 2 * DAY_MS).toISOString(),
    dateDue: new Date(Date.now() + 5 * DAY_MS).toISOString(),
  },
  {
    id: 'offer-2',
    name: 'checkout_flow_en_de.xliff',
    jobPartId: 100002,
    status: 'OPEN',
    clientName: 'IXT',
    clientUri: 'web:clientName:IXT',
    freelancerUsername: null,
    sourceLocale: 'en_US',
    targetLocale: 'de_DE',
    translationSkill: 'TRANSLATION',
    mediaType: 'SOFTWARE',
    subject: 'MARKETING',
    workUnits: 870,
    weightedWorkUnits: 739,
    price: '17.40',
    currency: 'USD',
    dateCreated: new Date(Date.now() - 1 * DAY_MS).toISOString(),
    dateDue: new Date(Date.now() + 3 * DAY_MS).toISOString(),
  },
  {
    id: 'offer-3',
    name: 'product_desc_en_ja.xliff',
    jobPartId: 100003,
    status: 'RESERVED',
    clientName: 'EUCF',
    clientUri: 'web:clientName:EUCF',
    freelancerUsername: 'translator_jane',
    sourceLocale: 'en_US',
    targetLocale: 'ja_JP',
    translationSkill: 'SCORING',
    mediaType: 'MARKETING',
    subject: 'CONSUMER_ELECTRONICS',
    workUnits: 540,
    weightedWorkUnits: 459,
    price: '10.80',
    currency: 'USD',
    dateCreated: new Date(Date.now() - 3 * DAY_MS).toISOString(),
    dateDue: new Date(Date.now() + 1 * DAY_MS).toISOString(),
  },
  {
    id: 'offer-4',
    name: 'help_center_en_fr.xliff',
    jobPartId: 100004,
    status: 'RESERVED',
    clientName: 'Customer Service',
    clientUri: 'web:clientName:Customer Service',
    freelancerUsername: 'translator_bob',
    sourceLocale: 'en_US',
    targetLocale: 'fr_FR',
    translationSkill: 'TRANSLATION',
    mediaType: 'SOFTWARE',
    subject: 'TECHNICAL',
    workUnits: 2100,
    weightedWorkUnits: 1785,
    price: '42.00',
    currency: 'USD',
    dateCreated: new Date(Date.now() - 4 * DAY_MS).toISOString(),
    dateDue: new Date(Date.now() + 2 * DAY_MS).toISOString(),
  },
  {
    id: 'offer-5',
    name: 'seller_guide_en_zh.xliff',
    jobPartId: 100005,
    status: 'ACCEPTED',
    clientName: 'AVS',
    clientUri: 'web:clientName:AVS',
    freelancerUsername: 'translator_mei',
    sourceLocale: 'en_US',
    targetLocale: 'zh_CN',
    translationSkill: 'TRANSLATION',
    mediaType: 'SOFTWARE',
    subject: 'BUSINESS',
    workUnits: 3200,
    weightedWorkUnits: 2720,
    price: '64.00',
    currency: 'USD',
    dateCreated: new Date(Date.now() - 5 * DAY_MS).toISOString(),
    dateDue: new Date(Date.now() - 1 * DAY_MS).toISOString(),
  },
];

const FAKE_SAVED_FILTERS = [
  {
    name: 'My OPEN offers',
    filterText: 'status=OPEN',
  },
  {
    // Intentionally no status — triggers the ATMS-34356 mandate error when applied
    name: 'Audible (no status)',
    filterText: 'clientUri=web:clientName:Audible',
  },
  {
    name: 'RESERVED + IXT',
    filterText: 'status=RESERVED|clientUri=web:clientName:IXT',
  },
];

const FAKE_GLOBAL_STATE = {
  translationSkills: {
    TRANSLATION: 'Translation',
    SCORING: 'Scoring',
    ADAPTATION: 'Adaptation',
    POST_EDITING: 'Post-Editing',
  },
  mediaTypes: {
    SOFTWARE: 'Software',
    MARKETING: 'Marketing',
    LEGAL: 'Legal',
    TECHNICAL: 'Technical Documentation',
  },
  subjects: {
    TECHNICAL: 'Technical',
    MARKETING: 'Marketing',
    CONSUMER_ELECTRONICS: 'Consumer Electronics',
    BUSINESS: 'Business',
    LEGAL: 'Legal',
  },
};

const FAKE_LOCALES = [
  { code: 'en_US', name: 'English (United States)' },
  { code: 'es_ES', name: 'Spanish (Spain)' },
  { code: 'de_DE', name: 'German (Germany)' },
  { code: 'fr_FR', name: 'French (France)' },
  { code: 'ja_JP', name: 'Japanese (Japan)' },
  { code: 'zh_CN', name: 'Chinese (Simplified)' },
];

const ok = body =>
  new Response(JSON.stringify(body), {
    status: 200,
    headers: { 'Content-Type': 'application/json' },
  });

const filterOffers = url => {
  const params = new URL(url, 'http://localhost').searchParams;
  const filterText = params.get('filterText') || '';
  const pageNum = parseInt(params.get('pageNum') || '0', 10);
  const pageSize = parseInt(params.get('pageSize') || '25', 10);

  let offers = [...FAKE_OFFERS];

  // parse filterText: 'status=OPEN RESERVED|clientUri=...'
  if (filterText) {
    const conditions = {};
    filterText.split('|').forEach(part => {
      const eqIdx = part.indexOf('=');
      if (eqIdx === -1) return;
      const key = part.slice(0, eqIdx);
      const values = part
        .slice(eqIdx + 1)
        .split(' ')
        .filter(Boolean);
      conditions[key] = values;
    });

    if (conditions.status) {
      offers = offers.filter(o => conditions.status.includes(o.status));
    }
    if (conditions.clientUri) {
      offers = offers.filter(o =>
        conditions.clientUri.some(
          v => o.clientUri && o.clientUri.includes(v.replace('web:clientName:', ''))
        )
      );
    }
    if (conditions.name) {
      offers = offers.filter(o =>
        conditions.name.some(v => o.name && o.name.toLowerCase().includes(v.toLowerCase()))
      );
    }
    if (conditions.translationSkill) {
      offers = offers.filter(o => conditions.translationSkill.includes(o.translationSkill));
    }
  }

  const totalPages = Math.max(1, Math.ceil(offers.length / pageSize));
  const page = offers.slice(pageNum * pageSize, (pageNum + 1) * pageSize);
  return { offers: page, totalPages };
};

export const fakeFetch = (url, options = {}) => {
  const path = url.replace(/^\/\/[^/]+\//, '/');
  const base = path.split('?')[0];
  const method = (options.method || 'GET').toUpperCase();

  // --- GET routes ---
  if (method === 'GET') {
    if (base === '/authenticate' || base === '/me/updateDateAcceptedTermsOfService') {
      return Promise.resolve(ok({}));
    }
    if (base === '/me/profiles') {
      return Promise.resolve(ok([]));
    }
    if (base === '/features') {
      return Promise.resolve(ok({}));
    }
    if (base === '/mediaTypes') {
      return Promise.resolve(ok(FAKE_GLOBAL_STATE.mediaTypes));
    }
    if (base === '/translationSkills') {
      return Promise.resolve(ok(FAKE_GLOBAL_STATE.translationSkills));
    }
    if (base === '/subjects') {
      return Promise.resolve(ok(FAKE_GLOBAL_STATE.subjects));
    }
    if (base === '/locale') {
      return Promise.resolve(ok(FAKE_LOCALES));
    }
    if (base === '/offer') {
      return Promise.resolve(ok(filterOffers(url)));
    }
    if (base === '/offerFilter') {
      return Promise.resolve(ok(FAKE_SAVED_FILTERS));
    }
    if (base === '/translator') {
      return Promise.resolve(ok([]));
    }
    if (base === '/vendor') {
      return Promise.resolve(ok({}));
    }
  }

  // --- POST routes ---
  if (method === 'POST') {
    if (base === '/getJobPartSegmentCounts') {
      const body = options.body ? JSON.parse(options.body) : {};
      const counts = (body.jobPartIds || []).reduce((acc, id) => {
        acc[id] = { confirmed: 10, total: 12 };
        return acc;
      }, {});
      return Promise.resolve(ok(counts));
    }
    if (base === '/offerFilter') {
      return Promise.resolve(ok({}));
    }
  }

  // --- PUT routes ---
  if (method === 'PUT') {
    if (base === '/offerFilter') {
      return Promise.resolve(ok({}));
    }
  }

  console.warn('[fakeApi] unhandled:', method, base);
  return Promise.resolve(
    new Response(JSON.stringify({ error: `fakeApi: unhandled ${method} ${base}` }), {
      status: 501,
      headers: { 'Content-Type': 'application/json' },
    })
  );
};
